import AreasMenu from '@src/main/ui/components/AreasMenu/AreasMenu';
import { type FC } from 'react';

const AreasMenuPage: FC = () => <AreasMenu />;

export default AreasMenuPage;
